export const LEGAL_PAGE_LOCALE = 'en';

export const LEGAL_PAGE_IDS = ['privacy-policy', 'terms-of-service'];

export const LEGAL_PAGE_META = {
  'privacy-policy': {
    label: 'Privacy Policy',
    route: '/privacy-policy',
    i18nTitleKey: 'legal.privacyPolicy.title',
    i18nContentKey: 'legal.privacyPolicy.content',
  },
  'terms-of-service': {
    label: 'Terms of Service',
    route: '/terms-of-service',
    i18nTitleKey: 'legal.termsOfService.title',
    i18nContentKey: 'legal.termsOfService.content',
  },
};

export const emptyLegalPageForm = () => ({
  title: '',
  contentHtml: '',
});
